// PLANTS SHADE
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const shadeData: PlantData[] = [
  {
    id: 'hosta-blue',
    name: 'Hosta - Blue',
    scientificName: 'Hosta spp',
    category: 'flower',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 21,
    daysToHarvest: 365,
    sun: 'shade',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['fern'],
    enemies: [],
    description: 'Large blue-green leaves, shade garden staple. Slug resistant varieties available.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '18-36 inches',
    spread: '24-36 inches',
    family: 'Asparagaceae',
    varieties: ['Blue Angel', 'Halcyon'],
    uses: ['ornamental', 'foliage', 'border']
  },
  {
    id: 'fern-lady',
    name: 'Fern - Lady',
    scientificName: 'Athyrium filix-femina',
    category: 'flower',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 30,
    daysToHarvest: 365,
    sun: 'shade',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['hosta'],
    enemies: [],
    description: 'Delicate lacy fronds, native woodland fern. Spreads slowly.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Athyriaceae',
    varieties: ['Lady Fern', 'Victoriae'],
    uses: ['woodland', 'shade garden', 'native']
  },
  {
    id: 'bleeding-heart',
    name: 'Bleeding Heart',
    scientificName: 'Lamprocapnos spectabilis',
    category: 'flower',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 30,
    daysToHarvest: 365,
    sun: 'shade',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['hosta'],
    enemies: [],
    description: 'Heart-shaped pink flowers on arching stems. Dies back in summer heat.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Papaveraceae',
    varieties: ['Old Fashioned', 'Gold Heart'],
    uses: ['spring blooms', 'shade garden', 'cut flowers']
  },
  {
    id: 'astilbe-pink',
    name: 'Astilbe - Pink',
    scientificName: 'Astilbe spp',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 21,
    daysToHarvest: 365,
    sun: 'shade',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['hosta', 'fern'],
    enemies: [],
    description: 'Feathery plumes of pink flowers above fern-like foliage. Needs moisture.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '12-18 inches',
    family: 'Saxifragaceae',
    varieties: ['Rheinland', 'Visions'],
    uses: ['shade garden', 'cut flowers', 'border']
  },
  {
    id: 'coral-bells',
    name: 'Coral Bells',
    scientificName: 'Heuchera spp',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 21,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['hosta'],
    enemies: [],
    description: 'Colorful foliage in purple, bronze, lime. Small bell flowers on stalks.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Saxifragaceae',
    varieties: ['Purple Palace', 'Lime Rickey'],
    uses: ['foliage', 'shade garden', 'border']
  },
  {
    id: 'solomons-seal',
    name: 'Solomons Seal',
    scientificName: 'Polygonatum biflorum',
    category: 'flower',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 30,
    daysToHarvest: 365,
    sun: 'shade',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['fern'],
    enemies: [],
    description: 'Arching stems with white bell flowers and blue berries. Native woodland.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '12-18 inches',
    family: 'Asparagaceae',
    varieties: ['Common', 'Variegated'],
    uses: ['woodland', 'shade garden', 'native']
  }
]
